import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  bookmarkDialog: {
    backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme].backdropColor,
    color: ({ activeTheme }) => theme.reader.colors[activeTheme].backdropOnColor,
    border: ({ activeTheme }) => `0.5px solid ${theme.reader.colors[activeTheme]?.backdropMutedColor}`,
  },
  title: {
    textAlign: 'center',
    '& h2': {
      fontSize: 16
    },
  },
  input: {
    marginBottom: 12,
    color: ({ activeTheme }) => theme.reader.colors[activeTheme].backdropOnColor,
    '& input': {
      fontSize: 14,
      padding: 10,
      borderRadius: 4,
      border: ({ activeTheme }) => `0.5px solid ${theme.reader.colors[activeTheme]?.backdropMutedColor}`,
      color: ({ activeTheme }) => theme.reader.colors[activeTheme].backdropOnColor,
      caretColor: theme.palette.colors.readerPrimaryColor,
      '&::placeholder': {
        color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropMutedColor,
        opacity: 1,
      },
      '&:focus': {
        border: `0.5px solid ${theme.palette.colors.readerPrimaryColor}`,
      },
    },
  },
  textarea: {
    width: '100%',
    fontFamily: 'inherit',
    color: ({ activeTheme }) => theme.reader.colors[activeTheme].backdropOnColor,
    backgroundColor: ({ activeTheme }) => theme.reader.colors[activeTheme].backdropColor,
    fontSize: 14,
    padding: 10,
    borderRadius: 4,
    border: ({ activeTheme }) => `0.5px solid ${theme.reader.colors[activeTheme]?.backdropMutedColor}`,
    caretColor: theme.palette.colors.readerPrimaryColor,
    '&::placeholder': {
        color: ({ activeTheme }) => theme.reader.colors[activeTheme]?.backdropMutedColor,
    },
    '&:focus': {
      border: `0.5px solid ${theme.palette.colors.readerPrimaryColor}`,
    },
    '&:focus-visible': {
      outline: 'unset',
    },
  },
  footer: {
    marginTop: 12,
    display: 'flex',
    justifyContent: 'space-between',
  },
  footerInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  footerIcon: {
    width: 16,
    height: 16,
    marginRight: 2,
  },
  saveButton: {
    marginLeft: 6,
    color: theme.palette.colors.readerPrimaryColor,
    border: `0.5px solid ${theme.palette.colors.readerPrimaryColor}`,
  },
  cancelButton: {
    color: ({ activeTheme }) => theme.reader.colors[activeTheme].backdropOnColor,
    border: ({ activeTheme }) => `0.5px solid ${theme.reader.colors[activeTheme].backdropOnColor}`,
  }
}));

export default useStyles;
